"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NPC = void 0;
const definables_1 = require("definables");
const QuestGiver_1 = require("./QuestGiver");
const Shop_1 = require("./Shop");
class NPC extends definables_1.Definable {
    constructor(options) {
        super(options.id);
        this._entityID = null;
        this._indicatorEntityID = null;
        this._position = null;
        this._actorImagePath = options.definition.actorImagePath;
        this._dialogue = options.definition.dialogue;
        this._direction = options.definition.startDirection;
        this._encounterID = options.definition.encounterID;
        this._innCost = options.definition.innCost;
        this._name = options.definition.name;
        this._questGiverID = options.definition.questGiverID;
        this._shopID = options.definition.shopID;
    }
    get actorImagePath() {
        return this._actorImagePath;
    }
    get dialogue() {
        if (this._dialogue !== undefined) {
            return this._dialogue;
        }
        throw new Error(this.getAccessorErrorMessage("dialogue"));
    }
    get direction() {
        return this._direction;
    }
    get entityID() {
        if (this._entityID !== null) {
            return this._entityID;
        }
        throw new Error(this.getAccessorErrorMessage("entityID"));
    }
    get indicatorEntityID() {
        if (this._indicatorEntityID !== null) {
            return this._indicatorEntityID;
        }
        throw new Error(this.getAccessorErrorMessage("indicatorEntityID"));
    }
    get name() {
        return this._name;
    }
    get position() {
        if (this._position !== null) {
            return this._position;
        }
        throw new Error(this.getAccessorErrorMessage("position"));
    }
    get questGiver() {
        if (typeof this._questGiverID !== "undefined") {
            return (0, definables_1.getDefinable)(QuestGiver_1.QuestGiver, this._questGiverID);
        }
        throw new Error(this.getAccessorErrorMessage("questGiver"));
    }
    get shop() {
        if (typeof this._shopID !== "undefined") {
            return (0, definables_1.getDefinable)(Shop_1.Shop, this._shopID);
        }
        throw new Error(this.getAccessorErrorMessage("shop"));
    }
    set direction(direction) {
        this._direction = direction;
    }
    set entityID(entityID) {
        this._entityID = entityID;
    }
    set indicatorEntityID(indicatorEntityID) {
        this._indicatorEntityID = indicatorEntityID;
    }
    set position(position) {
        this._position = position;
    }
    hasDialogue() {
        return typeof this._dialogue !== "undefined";
    }
    hasInnCost() {
        return typeof this._innCost !== "undefined";
    }
    hasQuestGiver() {
        return typeof this._questGiverID !== "undefined";
    }
    hasShopID() {
        return typeof this._shopID !== "undefined";
    }
    hasEncounterID() {
        return typeof this._encounterID !== "undefined";
    }
}
exports.NPC = NPC;
